import React from 'react';
import type { TapeColor } from '../types';
import '../styles/PinPolaroid.css';

type PinVariant = 'hero' | 'feature';

const TAPE_COLORS: Record<TapeColor, string> = {
  ochre: 'rgba(198,140,59,.55)',
  terracotta: 'rgba(194,90,58,.55)',
  sage: 'rgba(122,139,95,.55)',
};

interface PinPolaroidProps {
  variant?: PinVariant;
  flip?: boolean;
  media: React.ReactNode;
  caption?: string;
  stamp?: string;
  badge?: string;
  tapeColor?: TapeColor;
  rotation?: number;
  className?: string;
}

interface PolaroidStyle extends React.CSSProperties {
  '--rot'?: string;
  '--tape-bg'?: string;
}

const PinPolaroid: React.FC<PinPolaroidProps> = ({
  variant = 'hero',
  flip = false,
  media,
  caption,
  stamp,
  badge,
  tapeColor = 'ochre',
  rotation,
  className = '',
}) => {
  const r = rotation ?? (variant === 'hero' ? 5 : -2.5);
  const tape = TAPE_COLORS[tapeColor];

  const style: PolaroidStyle = {
    '--rot': `${r}deg`,
    '--tape-bg': tape,
  };

  return (
    <div
      className={`pin-polaroid pin-polaroid--${variant} ${flip ? 'is-flip' : ''} ${className}`}
      style={style}
    >
      <div className="pin-polaroid__tape" aria-hidden="true" />
      {badge && <div className="pin-polaroid__badge">{badge}</div>}
      <div className="pin-polaroid__frame">{media}</div>
      {caption && <div className="pin-polaroid__caption">{caption}</div>}
      {stamp && <div className="pin-polaroid__stamp">{stamp}</div>}
    </div>
  );
};

export default PinPolaroid;
